import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaEdit, FaSave, FaTrash, FaTimes } from 'react-icons/fa';
import IconRenderer from '../IconRenderer';

const SocialIconItem = ({ icon, onUpdate, onDelete }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [link, setLink] = useState(icon.link);

  const handleSave = () => {
    onUpdate(icon.id, { link });
    setIsEditing(false);
  };

  const handleCancel = () => {
    setLink(icon.link);
    setIsEditing(false);
  };

  const getIconColor = (type) => {
    const colors = {
      youtube: 'text-red-500',
      instagram: 'text-pink-500',
      facebook: 'text-blue-500',
      twitter: 'text-blue-400',
      tiktok: 'text-gray-300',
      linkedin: 'text-blue-600',
      whatsapp: 'text-green-500',
      custom: 'text-purple-500',
    };
    return colors[type?.toLowerCase()] || 'text-gray-400';
  };

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      className="bg-[#1a1a3e] border border-gray-800 rounded-xl p-4 hover:border-gray-700 transition-colors"
    >
      <div className="flex items-start gap-4">
        {/* Icon Preview */}
        <div className="flex-shrink-0">
          <div className="w-12 h-12 bg-[#0a0a1f] rounded-lg flex items-center justify-center">
            <IconRenderer 
              type={icon.type} 
              size={28} 
              className={getIconColor(icon.type)}
            />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-semibold mb-1">{icon.iconName}</h3>
          
          {!isEditing ? (
            <a
              href={icon.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 text-sm hover:text-purple-400 transition-colors truncate block"
            >
              {icon.link}
            </a>
          ) : (
            <input
              type="url"
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="Enter link URL"
              className="w-full px-3 py-2 bg-[#0a0a1f] border border-gray-700 rounded-lg text-white text-sm placeholder-gray-500 focus:border-purple-500 focus:outline-none"
            />
          )}
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          {!isEditing ? (
            <>
              <motion.button
                onClick={() => setIsEditing(true)}
                className="p-2 bg-[#0a0a1f] hover:bg-purple-600 text-gray-400 hover:text-white rounded-lg transition-colors"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaEdit size={16} />
              </motion.button>
              <motion.button
                onClick={() => onDelete(icon.id)}
                className="p-2 bg-[#0a0a1f] hover:bg-red-600 text-gray-400 hover:text-white rounded-lg transition-colors"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaTrash size={16} />
              </motion.button>
            </>
          ) : (
            <>
              <motion.button
                onClick={handleSave}
                className="p-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaSave size={16} />
              </motion.button>
              <motion.button
                onClick={handleCancel}
                className="p-2 bg-gray-600 hover:bg-gray-700 text-white rounded-lg transition-colors"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                <FaTimes size={16} />
              </motion.button>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default SocialIconItem;
